<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.intendedFor"
              label="适用人群"
              removable
              :messages="message"
              :error="!!error.intendedForErrors.length"
              :error-messages="error.intendedForErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.projectDuration"
              label="项目时长"
              removable
              :messages="message"
              :error="!!error.projectDurationErrors.length"
              :error-messages="error.projectDurationErrors"
            />
          </div>
          <div class='flex md4 sm6 xs12' v-show="insertData.imageUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imageUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='课程封面图'>
              <va-file-upload
                type='single'
                v-model='insertData.image'
                @input="uploadOnlineActionImage"
              />
            </va-card>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="服务标签"
              v-model="insertData.tags"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.learnedSkill"
              label="你将学习的技能"
              removable
              placeholder="请输入以逗号分割的技能"
              :messages="message"
              :error="!!error.leanedSkillErrors.length"
              :error-messages="error.leanedSkillErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="你将收获">
              <va-tree-node
                v-for="reward in insertData.willReward"
                :key="reward.id"
              >
                <div class="flex row align--center">
                  <va-input v-model="reward.reward" removable class="mb-0"/>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink" d
                    style="cursor: pointer;"
                    @click.native="removeReward(reward)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addReward()">
                  新增收获
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.shortDescription"
              type="textarea"
              label="课程简短描述"
              maxlength="255"
              @input="shortDescriptionDescInput"
              removable
              :messages="message + shortDescriptionRemnant + remnant255"
              :error="!!error.shortDescriptionErrors.length"
              :error-messages="error.shortDescriptionErrors"
            ></va-input>
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              type="textarea"
              label="课程介绍"
              maxlength="400"
              @input="descriptionDescInput"
              removable
              :messages="message + descriptionRemnant + remnant400"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.outline"
              type="textarea"
              label="课程大纲"
              maxlength="400"
              @input="outlineDescInput"
              removable
              :messages="message + outlineRemnant + remnant400"
              :error="!!error.outlineErrors.length"
              :error-messages="error.outlineErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-tree-category isOpen label="课程大纲列表">
              <va-tree-node
                v-for="course in insertData.courses"
                :key="course.id"
              >
                <div class="flex row align--center">
                  <div class="flex md2 sm6 xs12">
                    <va-input v-model="course.serial" label="序号" removable class="mb-0"/>
                  </div>
                  <div class="flex md3 sm6 xs12">
                    <va-input v-model="course.name" label="标题" removable class="mb-0"/>
                  </div>
                  <div class="flex md3 sm6 xs12">
                    <va-input v-model="course.inspectionMethod" label="考察方式" removable class="mb-0"/>
                  </div>
                  <div class="flex md3 sm6 xs12">
                    <va-input v-model="course.teachingDuration" label="授课周期" removable class="mb-0"/>
                  </div>
                  <va-icon
                    name="ion ion-md-close"
                    color="info"
                    class="ml-2 pa-1 shrink"
                    style="cursor: pointer;"
                    @click.native="removeCourse(course)"
                  />
                </div>
              </va-tree-node>
              <va-tree-node>
                <va-button class="mb-2" @click="addCourse()">
                  新增课程
                </va-button>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="课程导师"
              v-model="insertData.teachers"
              multiple
              :options="computedTeachers"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越小越靠前"
              removable
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
              type="number"
              :min="1"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import tagApi from '../../api/serviceTag'
import teacherApi from '../../api/teacher'
import onlineActionApi from '../../api/onlineAction'
import uploadApi from '../../api/upload'
import { copyObject } from '../../utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        image: [],
        imageUrl: '',
        name: '',
        intendedFor: '',
        projectDuration: '',
        learnedSkill: '',
        willReward: [],
        description: '',
        shortDescription: '',
        outline: '',
        courses: [],
        teachers: [],
        tags: [],
        sortNum: null,
      },
      message: ['Required field '],
      serviceTags: [],
      teachers: [],
      error: {
        nameErrors: [],
        intendedForErrors: [],
        projectDurationErrors: [],
        leanedSkillErrors: [],
        descriptionErrors: [],
        shortDescriptionErrors: [],
        outlineErrors: [],
        sortNumErrors: [],
      },
      showId: false,
      submitButtonStatus: true,
      title: '新增在线项目实战',
      remnant255: '/255',
      remnant400: '/400',
      descriptionRemnant: 400,
      shortDescriptionRemnant: 255,
      outlineRemnant: 400,
    }
  },
  computed: {
    computedTags () {
      return this.serviceTags.map(x => {
        return x.name
      })
    },
    computedTeachers () {
      return this.teachers.map(x => {
        return x.name
      })
    },
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.intendedForErrors.length &&
          !this.error.projectDurationErrors.length &&
          !this.error.leanedSkillErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.shortDescriptionErrors.length &&
          !this.error.outlineErrors.length &&
          !this.error.sortNumErrors.length
    },
    flipTags () {
      const flipTags = {}
      this.serviceTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    flipTeachers () {
      const flipTeachers = {}
      this.teachers.forEach(x => {
        flipTeachers[x.name] = x.id
      })
      return flipTeachers
    },
  },
  created () {
    const params = this.$route.params
    console.log(params)
    if (params.id != null) {
      this.showId = true
      this.title = '编辑在线项目实战'
      // 通过id获取详情
      onlineActionApi.getOnlineAction(params.id).then(response => {
        copyObject(response, this.insertData)
        this.descriptionRemnant = 400 - this.insertData.description.length
        this.shortDescriptionRemnant = 255 - this.insertData.shortDescription.length
        this.outlineRemnant = 400 - this.insertData.outline.length
        if (response.hasOwnProperty('learnedSkills') && response.learnedSkills.length !== 0) {
          this.insertData.learnedSkill = response.learnedSkills.join(',')
        }
        if (response.hasOwnProperty('teachers') && response.teachers.length !== 0) {
          const that = this
          that.insertData.teachers = []
          response.teachers.forEach(function (x) {
            that.insertData.teachers.push(x.name)
          })
        }
        if (response.hasOwnProperty('tags') && response.tags.length !== 0) {
          const that = this
          that.insertData.tags = []
          response.tags.forEach(x => {
            that.insertData.tags.push(x.name)
          })
        }
        if (response.hasOwnProperty('willReward') && response.willReward.length !== 0) {
          const that = this
          this.insertData.willReward = []
          response.willReward.forEach(x => {
            that.insertData.willReward.push({
              id: Math.floor(Math.random() * 100000),
              reward: x,
            })
          })
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
    this.listTag()
    this.listTeacher()
  },
  methods: {
    listTag () {
      tagApi.listTag().then(response => {
        this.serviceTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    listTeacher (pageNumber = 1) {
      const params = {
        pageSize: 100,
        pageNumber: pageNumber,
      }
      teacherApi.listTeacher(params).then(response => {
        this.teachers = response.teachers
      })
    },
    addReward () {
      this.insertData.willReward.push({
        id: Math.floor(Math.random() * 100000),
        reward: '你将收获',
      })
    },
    removeReward (reward) {
      this.insertData.willReward = this.insertData.willReward.filter(x => x !== reward)
    },
    addCourse () {
      this.insertData.courses.push({
        id: Math.floor(Math.random() * 100000),
        serial: 1,
        name: '课程标题',
        inspectionMethod: '考察方式',
        teachingDuration: '授课周期',
      })
    },
    removeCourse (course) {
      this.insertData.courses = this.insertData.courses.filter(x => x !== course)
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imageUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        serviceId: this.insertData.serviceId,
        imageUrl: this.insertData.imageUrl,
        name: this.insertData.name,
        intendedFor: this.insertData.intendedFor,
        projectDuration: this.insertData.projectDuration,
        learnedSkill: this.insertData.learnedSkill,
        description: this.insertData.description,
        shortDescription: this.insertData.shortDescription,
        outline: this.insertData.outline,
        tagIds: this.insertData.tags.map(tag => {
          return this.flipTags[tag]
        }),
        teacherIds: this.insertData.teachers.map(teacher => {
          return this.flipTeachers[teacher]
        }),
        willReward: this.insertData.willReward.map(x => {
          delete x.id
          return x.reward
        }),
        courses: this.insertData.courses.map(x => {
          delete x.id
          return x
        }),
        sortNum: this.insertData.sortNum,
      }
      if (this.insertData.id !== null) {
        data.id = this.insertData.id
        onlineActionApi.updateOnlineAction(this.insertData.id, data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'onlineAction' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      } else {
        onlineActionApi.saveOnlineAction(data).then(response => {
          if (response.success === true) {
            this.$router.push({ name: 'onlineAction' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          alert(error)
        })
      }
    },
    clickCancel () {

    },
    uploadOnlineActionImage () {
      if (this.insertData.image.length === 0) return
      const formData = new FormData()
      formData.append('type', 'IMAGE')
      formData.append('file', this.insertData.image[0])
      uploadApi.uploadImage(formData).then(response => {
        console.log(response)
        this.insertData.imageUrl = response.url
      })
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.intendedForErrors = this.insertData.intendedFor ? [] : ['intendedFor is required']
      this.error.projectDurationErrors = this.insertData.projectDuration ? [] : ['projectDuration is required']
      this.error.leanedSkillErrors = this.insertData.learnedSkill ? [] : ['learnedSkill is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
      this.error.shortDescriptionErrors = this.insertData.shortDescription ? [] : ['shortDescription is required']
      this.error.outlineErrors = this.insertData.outline ? [] : ['outline is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
    },
    shortDescriptionDescInput () { this.shortDescriptionRemnant = 255 - this.insertData.shortDescription.length },
    descriptionDescInput () { this.descriptionRemnant = 400 - this.insertData.description.length },
    outlineDescInput () { this.outlineRemnant = 400 - this.insertData.outline.length },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
